//"Creating Figures": 0.790196,
/**
 * To populate below simply add a new key for scale eg.. scale1, scale2 ...
 * in scale object add skill name and value eg..
 *  scale1: {
 *   "Creating Figures": 0.790196,
 *   "Select Data & Features": 0.936601,
 *  }
 */

const tsDataStaarEnglish_i = {
  // scale1: {},
  // scale2: {}
}

export default tsDataStaarEnglish_i
